<template>
<div>
    <div class="col-md-12">
        <div class="panel panel-cascade">
            <div class="panel-body" style="background-color:#c5dadf;"> 
                <div class="form-horizontal cascde-forms">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Amount</th>
                                <th>Pay Date</th>
                                <th>Receipt no.</th>
                                <th>Collected By</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(meta,index) in this.metajson" :key="meta.id">
                                <td>{{ index+1 }}</td>
                                <td>{{meta.paid_principal}}</td>
                                <td>{{meta.transactiondate}}</td>
                                <td>{{meta.receiptno}}</td>
                                <td>{{ employees.find(o=>o.id==meta.collectedbyid)?.name }}</td>
                                <td>
                                    <div v-if="meta.rollover==0">
                                        <button class="badge btn-danger"   @click="confirmDelete(meta.paymenttransactionid)">Reverse</button>
                                    </div>
                                    <div v-else>
                                        <span class="badge badge-success">Carry Forward</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div> 
            </div>
        </div>
        
    </div>
</div>
</template>
<script>
import { mapGetters } from 'vuex'
import Constants from '../../components/utilities/Constants.vue'
import axios from 'axios';
export default {
     mixins:[Constants],
     props:['emiitem'],
     data(){
         return {
             metajson:[],
         }
     },
     mounted(){
        // console.log("PartialPaymentDetail mounted", this.emiitem);
        if(this.emiitem!=null){
            this.metajson = JSON.parse(this.emiitem.meta_json || []);
        }
     },
    computed:{
        ...mapGetters([
		      'employees','registers','edititem'
	    ])
    },
    methods:{
        confirmDelete(paymenttransactionid){
            if (confirm("Do you really want to delete this EMI?")) {
                axios.post('api/loanemi/delete', {
                    paymentid: paymenttransactionid,
                    emiid: this.emiitem.id
                })
                .then(response => {
                    console.log(response.data);
                    this.$emit('refresh');
                })
                .catch(error => {
                    console.error(error);
                });
            }
        }
    }
}
</script>